module.exports = __webpack_public_path__ + "static/image-bae55baf53583ffd0bc22e6fed6c5795.jpg";